module.exports = __webpack_public_path__ + "static/img/img-dg.26bf04c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/pc/img-dg.png
// module id = 9AQV
// module chunks = 0